import { useCallback } from 'react';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';
import type { NotificationHook } from '@/models/component.types';

interface NotificationOptions {
  title?: string;
  message: string;
  autoClose?: number | false;
  withCloseButton?: boolean;
}

export const useNotification = (): NotificationHook => {
  const showSuccess = useCallback((message: string | NotificationOptions) => {
    const options = typeof message === 'string' ? { message } : message;
    notifications.show({
      ...options,
      color: 'green',
      icon: <IconCheck size={20} />,
      autoClose: options.autoClose ?? 1000,
      withCloseButton: options.withCloseButton ?? true,
    });
  }, []);

  const showError = useCallback((message: string | NotificationOptions) => {
    const options = typeof message === 'string' ? { message } : message;
    notifications.show({
      ...options,
      color: 'red',
      icon: <IconX size={20} />,
      autoClose: options.autoClose ?? 10000,
      withCloseButton: options.withCloseButton ?? true,
    });
  }, []);

  return {
    showSuccess,
    showError,
  };
};